import { render } from "./GalleryConfigurator.vue?vue&type=template&id=875a0448&ts=true"
import script from "./GalleryConfigurator.vue?vue&type=script&lang=ts"
export * from "./GalleryConfigurator.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/soctio/singlepage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__